import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { isEmpty, isNil } from 'lodash';
import {
  classroomInsightsWarmup,
  useLiveClassroomStudentData,
  useTrackerInstanceSectionClassroomInsightsStatus,
  useTrackerInstanceSectionDetail
} from 'sdk';

import ClassroomDashboard from './components/ClassroomDashboard/index';
import ClassroomHeader from './components/ClassroomHeader/index';
import ClassroomStatuses from './components/ClassroomStatuses/index';
import ClassroomStatusesSkeleton from './components/ClassroomStatusesSkeleton/index';

import styles from './style.module.scss';

const LiveClassroom = () => {
  const { trackerInstanceSectionId } = useParams();

  const { data: trackerInstanceSectionDetail } =
    useTrackerInstanceSectionDetail({
      trackerInstanceSectionId
    });

  const { data: studentData, refetch: refetchStudentData } =
    useLiveClassroomStudentData({
      trackerInstanceSectionId
    });

  const { data: insightsStatus, refetch: refetchInsightsStatus } =
    useTrackerInstanceSectionClassroomInsightsStatus({
      trackerInstanceSectionId
    });

  useEffect(() => {
    const interval = setInterval(() => {
      refetchStudentData();
      refetchInsightsStatus();
    }, 15000);

    return () => clearInterval(interval);
  });

  useEffect(() => {
    classroomInsightsWarmup();
  }, []);

  const students = useMemo(() => {
    if (isNil(studentData)) return null;
    if (isEmpty(studentData)) return [];

    return Object.entries(studentData)
      .map(([key, item], _) =>
        item.map((student) => ({ ...student, status: key }))
      )
      .flat();
  }, [studentData]);

  return (
    <div className={styles.container}>
      <ClassroomHeader
        sectionDetails={trackerInstanceSectionDetail}
        studentsCount={isNil(students) ? 0 : students.length}
        trackerInstanceSectionId={trackerInstanceSectionId}
      />
      {isNil(studentData) && <ClassroomStatusesSkeleton />}
      {!isNil(studentData) && <ClassroomStatuses studentData={studentData} />}
      <ClassroomDashboard students={students} insightsStatus={insightsStatus} />
    </div>
  );
};

export default LiveClassroom;
